import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LOGO_URL } from "../data/site";

const LINKS = [
  { label: "Collection", href: "#collection" },
  { label: "Story", href: "#story" },
  { label: "Craft", href: "#craft" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#FFFFFF]/75 border-b border-border" : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1600px] mx-auto px-4 md:px-8 h-20 grid grid-cols-2 md:grid-cols-3 items-center">
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-foreground/80 hover:text-foreground transition-colors duration-300 relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-accent group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </div>

        <a
          href="#top"
          data-testid="nav-brand"
          className="justify-self-start md:justify-self-center flex items-center"
        >
          <img
            src={LOGO_URL}
            alt="SleepVista"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </a>

        <div className="justify-self-end">
          <a
            href="#contact"
            data-testid="nav-contact-cta"
            className="inline-flex items-center px-5 py-2.5 rounded-full bg-foreground text-primary-foreground text-sm tracking-wide hover:bg-accent hover:text-foreground transition-colors duration-300"
          >
            Enquire
          </a>
        </div>
      </nav>
    </motion.header>
  );
};
